
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FilosofiaSection from './components/FilosofiaSection';
import StoriaSection from './components/StoriaSection';
import StatisticheSection from './components/StatisticheSection';
import ProgettiSection from './components/ProgettiSection';
import MaterialiSection from './components/MaterialiSection';
import PassioneSection from './components/PassioneSection';
import VisioneFuturoSection from './components/VisioneFuturoSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

export default function HomePage() {
  const scrollToSection = (sectionId: string) => {
    const el = document.getElementById(sectionId);
    if (el) {
      try {
        el.scrollIntoView({ behavior: 'smooth' });
      } catch (error) {
        console.warn('Smooth scroll not supported, falling back to instant scroll.', error);
        el.scrollIntoView();
      }
    } else {
      console.warn(`Element with id "${sectionId}" not found.`);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <Navbar onNavigate={scrollToSection} />
      <HeroSection onNavigate={scrollToSection} />
      <FilosofiaSection />
      <StoriaSection />
      <StatisticheSection />
      <ProgettiSection />
      <MaterialiSection />
      <PassioneSection />
      <VisioneFuturoSection />
      <CTASection onNavigate={scrollToSection} />
      <FooterSection />
    </div>
  );
}
